<template>
	<table class="b-table table table-striped b-table-stacked-md">
		<thead>
			<tr>
				<th></th>
				<th>Nome Completo</th>
				<th>Posição Familiar</th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="familiar in familiares" :key="familiar.id">
				<td>
					<input type="radio" :id="familiar.id" :value="familiar" v-model="responsavel" />
				</td>
				<td>
					<strong>{{ familiar.nome_completo }}</strong>
					<br />
					<span v-if="familiar.documento">
						<span v-if="familiar.documento.nis">NIS: {{ familiar.documento.nis }}</span>
						<span v-else>
							<b-link
								href="#"
								v-b-tooltip.hover
								title="Não sabe o número do NIS ou não foi inserido no cadastro!"
							>
								NIS:
								<b-icon
									icon="exclamation-triangle-fill"
									variant="warning"
									animation="fade"
								></b-icon>
							</b-link>
						</span>
					</span>
					<br />
					Sexo:
					<span v-if="familiar.sexo == 1"> MASCULINO </span>
					<span v-if="familiar.sexo == 2"> FEMININO </span>
					<span v-else> INTERSEXO </span>
					<br />
					Idade: {{ familiar.idade }} ano(s)
				</td>
				<td>
					<span v-for="posicao in $root.arrays.posicao_familiar" :key="posicao.id">
						<span v-if="posicao.id == familiar.posicao_familiar">
							{{ posicao.value }}
						</span>
					</span>
				</td>
			</tr>
		</tbody>
	</table>
</template>
<script>
export default {
	props: ["familiares"],
	data() {
		return { responsavel: "" };
	},
	watch: {
		responsavel(newRole) {
			this.$emit("selected", newRole);
		},
	},
};
</script>
